import { match } from 'ts-pattern';
import { IGetFavoriteItemByIdUsecase } from '@modules/favorite/domain/ports/getFavoriteItemById.usecase.port';
import { GetMemberFavoriteCollectionQueryDocument, GetMemberFavoriteProductQueryDocument, GetMemberFavoriteRecipeQueryDocument } from '@modules/libs/graphql/generated/graphql';
import { ModuleType } from '@shared/types/module.type';
import { left, right } from '@shared/utils/either.utils';
import { IFavoriteRepository } from '../ports/favorite.repository.port';
export class GetFavoriteItemByIdUsecase implements IGetFavoriteItemByIdUsecase {
  constructor(private readonly favoriteRepository: IFavoriteRepository) {}
  async handle(id: number, module: ModuleType): IGetFavoriteItemByIdUsecase.getFavoriteItemByIdOutput {
    const data = match(module).with(ModuleType.Product, () => ({
      query: GetMemberFavoriteProductQueryDocument,
      variables: {
        productIds: [id]
      },
      responseKey: 'getMemberFavoriteProduct'
    })).with(ModuleType.Collection, () => ({
      query: GetMemberFavoriteCollectionQueryDocument,
      variables: {
        collectionIds: [id]
      },
      responseKey: 'getMemberFavoriteCollection'
    })).with(ModuleType.Recipe, () => ({
      query: GetMemberFavoriteRecipeQueryDocument,
      variables: {
        recipeIds: [id]
      },
      responseKey: 'getMemberFavoriteRecipe'
    })).otherwise(() => null);
    if (!data) return left('Module not found');
    const result = await this.favoriteRepository.getFavoriteItemById(data.query, data.variables, data.responseKey);
    const value = result.value;
    if (result.isLeft()) return left(value);
    return right(value);
  }
}